// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"df5b51fb","787":"244daa00"}[chunkId] + ".chunk.js";
};